import React from 'react';
import { Table } from '@/components/atoms/Table';

import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/atoms/Button';

import { Section } from '@/components/atoms/Section';

import { TableCell, TableRow } from '@/components/atoms/Table/Table.type';
import { Cell, Column } from 'react-table';

interface TableSectionProps {
    titleId: string;
    subtitleId: string;
    actionButtonId: string;
    onActionClick: () => void;
    onRowClick: (cell: Cell<TableRow, TableCell<unknown>> | undefined) => void;
    tableProps: {
        rows: TableRow[];
        columns: Column<TableRow>[];
        isLoading: boolean;
        emptyMessageId: string;
        isSortable?: boolean;
        hasPagination?: boolean;
    };
}

export const GroupingSection: React.FC<TableSectionProps> = ({
    titleId,
    subtitleId,
    actionButtonId,
    onActionClick,
    onRowClick,
    tableProps,
}) => (
    <Section
        title={titleId}
        subtitle={subtitleId}
        actions={
            <Button buttonType="primary" onClick={onActionClick}>
                <FormattedMessage id={actionButtonId} />
            </Button>
        }
    >
        <Table
            isSearchable={true}
            rows={tableProps.rows}
            onRowClick={onRowClick}
            columns={tableProps.columns}
            emptyMessageId={tableProps.emptyMessageId}
            isSortable={tableProps.isSortable ?? false}
            hasPagination={tableProps.hasPagination ?? true}
            isLoading={tableProps.isLoading}
        />
    </Section>
);
